import PayoutsIncomeChart from './PayoutsIncomeChart';

export default PayoutsIncomeChart;
